import i18n from './index';
import {createLanguagePreference} from './languagePreference';
export {APP_LANGUAGES} from './languagePreference';
export const languageSettings = createLanguagePreference({i18n, getDeviceLanguage: () => navigator.language, storage: {
    getItem: key => window.localStorage.getItem(key),
    setItem: (key, value) => window.localStorage.setItem(key, value),
}});
